import { IoMdAddCircle } from "react-icons/io";
import { MdDelete } from "react-icons/md";
import { FaSave } from "react-icons/fa";
import { FaDownload } from "react-icons/fa";
import { IoIosSend } from "react-icons/io";
import ReactDatePicker from "react-datepicker";
import ReactSelect from "react-select";
import InvoicePreview from "./InvoicePreview";
import { FaArrowLeft } from "react-icons/fa";
import * as Yup from "yup";
import {
  Formik, Form, Field, ErrorMessage, FieldArray, useFormikContext,
} from "formik";
import React, { useEffect, useState } from "react";
import moment from "moment";
import CurrencyInput from "react-currency-input-field";
import { useDispatch, useSelector } from "react-redux";
import { getCustomersByBusiness, addCustomer } from "../../../redux/reducers/customerSlice";
import { getProductList } from "../../../redux/reducers/productSlice";
import { addInvoice } from "../../../redux/reducers/invoiceSlice";
import { getTaxList } from "../../../redux/reducers/taxSlice";
import { getDiscountList } from "../../../redux/reducers/discountSlice";
import { useNavigate, useLocation } from "react-router-dom";
import { getIndividualnvoice, updateInvoice } from "../../../redux/reducers/invoiceSlice";
import { addOrder } from "../../../redux/reducers/orderSlice";
import Spinner from "../../../components/Spinner";
import { formatCurrency } from "../../../utils/currency";
import { Modal } from "react-bootstrap";
import { IoMdPersonAdd } from "react-icons/io";

// ── Shared react-select styles ──────────────────────────
const selectStyles = {
  control: (base, state) => ({
    ...base,
    borderRadius: "10px",
    border: state.isFocused ? "1.5px solid #28B0C4" : "1.5px solid #e2e8f0",
    boxShadow: state.isFocused ? "0 0 0 3px rgba(40,176,196,0.1)" : "none",
    backgroundColor: "#f8fafc",
    minHeight: "42px",
    fontSize: "14px",
    transition: "all 0.15s ease",
    "&:hover": { borderColor: "#28B0C4" },
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? "#28B0C4" : state.isFocused ? "#f0fbfc" : "white",
    color: state.isSelected ? "white" : "#1e293b",
    fontSize: "13px",
    borderRadius: "6px",
    margin: "1px 4px",
    width: "calc(100% - 8px)",
  }),
  placeholder: (base) => ({ ...base, color: "#94a3b8", fontSize: "13px" }),
  menu: (base) => ({ ...base, borderRadius: "12px", boxShadow: "0 4px 20px rgba(0,0,0,0.1)", border: "1px solid #f1f5f9" }),
  multiValue: (base) => ({ ...base, backgroundColor: "rgba(40,176,196,0.1)", borderRadius: "6px" }),
  multiValueLabel: (base) => ({ ...base, color: "#28B0C4", fontWeight: 600, fontSize: "12px" }),
  multiValueRemove: (base) => ({ ...base, color: "#28B0C4", "&:hover": { backgroundColor: "#28B0C4", color: "white" } }),
};

const smallSelectStyles = {
  ...selectStyles,
  control: (base, state) => ({
    ...selectStyles.control(base, state),
    minHeight: "36px",
    fontSize: "12px",
  }),
};

const calculateTieredPrice = (product, quantity) => {
  if (!product?.pricingTiers || product.pricingTiers.length === 0) {
    return product?.price || 0;
  }
  const sortedTiers = [...product.pricingTiers].sort((a, b) => b.minQuantity - a.minQuantity);
  const tier = sortedTiers.find(t => quantity >= t.minQuantity);
  return tier ? tier.price : (product.price || 0);
};

export default function InvoiceForm() {
  const [invoiceid, setInvoiceid] = useState("");
  useEffect(() => {
    const rand = Math.floor(Math.random() * (99999 - 10000 + 1)) + 10000;
    setInvoiceid(rand);
  }, []);

  const baseURL = process.env.REACT_APP_BASEURL;
  const dispatch = useDispatch();
  const { activeBusinessId, selectedBusiness } = useSelector((state) => state.business);
  const { loading } = useSelector((state) => state.invoice);
  const selectedBusinessId = activeBusinessId || localStorage.getItem("activeBusinessId");
  const fallbackCurrency = useSelector((state) => state.business?.currencyContext?.currency);
  const currencyContext = selectedBusiness?.jssettings?.currency || fallbackCurrency || 'CAD';
  const taxByBusiness = selectedBusiness?.taxByBusiness || {};
  const taxType = taxByBusiness?.type || 'bypass';
  const taxPercentage = taxByBusiness?.percentage || 0;
  const taxLabel = taxByBusiness?.label || 'Tax';
  const [isReviewMode, setIsReviewMode] = useState(false);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isEdit = searchParams.get("edit") === "true";
  const editId = searchParams.get("id");
  const isOrder = searchParams.get("type") === "order";

  // --- Quick Add Customer State ---
  const [showQuickAdd, setShowQuickAdd] = useState(false);
  const [quickCustomer, setQuickCustomer] = useState({ name: "", email: "" });
  const customerLoading = useSelector((state) => state.customer.loading);

  useEffect(() => {
    if (selectedBusinessId) {
      dispatch(getCustomersByBusiness(selectedBusinessId));
      dispatch(getProductList(selectedBusinessId));
      dispatch(getTaxList(selectedBusinessId));
      dispatch(getDiscountList(selectedBusinessId));
    }
    fetch(baseURL + "/currency").then((res) => res.json()).then((data) => setCurrency(data.data));
    if (isEdit && editId) dispatch(getIndividualnvoice(editId));
  }, [dispatch, selectedBusinessId, isEdit, editId]);

  const individualInvoice = useSelector((state) => state.invoice.individualInvoice);
  const customerdata = useSelector((state) => state.customer.customerList);
  const customereoptions = customerdata?.map((e) => ({
    label: e?.name, value: e?._id, email: e?.email,
    street: e?.address?.street, city: e?.address?.city,
    state: e?.address?.state, zipCode: e?.address?.zipCode, country: e?.address?.country,
  }));

  const productdata = useSelector((state) => state.product.productList);
  const productsoptions = productdata?.map((e) => ({ 
    label: e?.name, 
    value: e?._id, 
    price: e?.price,
    pricingTiers: e?.pricingTiers || []
  }));

  const taxData = useSelector((state) => state.tax.taxList);
  const discountData = useSelector((state) => state.discount.discountList);
  const dynamicTaxOptions = taxData?.filter(t => t.status === "active").map(t => ({
    label: `${t.name} (${t.percentage}%)`, value: t._id, rate: t.percentage, name: t.name
  }));
  const dynamicDiscountOptions = discountData?.filter(d => d.status === "active").map(d => ({
    label: `${d.name} (${d.type === 'percentage' ? d.value + '%' : '$' + d.value})`,
    value: d._id, rate: d.value, type: d.type, name: d.name
  }));

  const [currency, setCurrency] = useState();
  const currencyoptions = currency?.map((e) => ({ label: e?.code, value: e?.code, country: e?.name }));

  const todaysdate = moment().format("YYYY-MM-DD");
  const duedate = moment(todaysdate, "YYYY-MM-DD").add(7, "d");
  const [recurringChecked, setRecurringChecked] = useState(false);

  const initialValues = (isEdit && individualInvoice) ? {
    ...individualInvoice,
    business: individualInvoice.business?._id || individualInvoice.business,
    selectedCustomer: customereoptions?.find(c => c.value === (individualInvoice.customer?._id || individualInvoice.customer)),
    customer: individualInvoice.customer?._id || individualInvoice.customer,
    appliedTaxes: individualInvoice.appliedTaxes?.map(t => ({
      label: `${t.name} (${t.percentage}%)`, value: t.taxId, rate: t.percentage, name: t.name
    })) || []
  } : {
    invoiceDate: todaysdate, invoiceDueDate: duedate.format("YYYY-MM-DD"),
    business: selectedBusinessId, customer: "", selectedCustomer: "", currency: currencyContext,
    productDetail: [{ id: "", product: "", productName: "", quantity: 1, rate: 0, discountamount: 0, total: "", discountList: [], tax: 0 }],
    status: "Sent", netAmount: 0, invoiceDiscount: 0, invoiceTax: 0, totalAmount: 0,
    shippingCharge: 0, appliedTaxes: [], appliedDiscounts: [], terms: "", notes: "",
    recurring: { isRecurring: recurringChecked, interval: "yearly", custom: { frequencyType: "", frequencyValue: 0 }, recurrenceEndType: "continuous", endDate: "", numberOfInvoices: 0 },
  };

  const validationSchema = Yup.object({
    business: Yup.string().required("Required"),
    invoiceDate: Yup.date().required().min(moment().subtract(1, "days"), "Invoice Date should be today or later"),
    invoiceDueDate: Yup.date().required().min(moment().subtract(1, "days"), "Due Date should be today or later"),
    customer: Yup.string().required("Customer Is Required"),
    currency: Yup.string().required("Currency Is Required"),
    productDetail: Yup.array().of(Yup.object().shape({
      product: Yup.string().required("Product is required"),
      quantity: Yup.number().required("Quantity is Required").min(1, "Min 1"),
      rate: Yup.number().required("Rate is Required").min(0, "Min 0"),
    })).min(1, "Need at least one product"),
  });

  const navigate = useNavigate();
  const onSubmit = (values, { setFieldError }) => {
    const netTotal = parseFloat(values.netAmount) || 0;
    const itemDiscount = parseFloat(values.invoiceDiscount) || 0;
    const taxableAmount = netTotal - itemDiscount;
    const formattedTaxes = values.appliedTaxes?.map(tax => ({
      taxId: tax.value, name: tax.name, percentage: tax.rate,
      amount: (taxableAmount * (parseFloat(tax.rate) || 0)) / 100
    })) || [];
    const finalValues = { ...values, appliedTaxes: formattedTaxes };
    
    if (isOrder) {
      const orderValues = {
        customerId: values.customer,
        items: values.productDetail.map(p => ({
          productId: p.product,
          productName: p.productName,
          quantity: p.quantity,
          unitPrice: p.rate,
          lineTotal: p.total
        })),
        totals: {
          subtotal: values.netAmount,
          total: values.totalAmount
        },
        customerNote: values.notes,
        paymentMethod: 'MANUAL'
      };
      dispatch(addOrder(orderValues)).then((res) => { if (!res.error) navigate("/orders"); });
    } else if (isEdit && editId) {
      dispatch(updateInvoice({ id: editId, values: finalValues })).then((res) => { if (!res.error) navigate("/invoice"); });
    } else {
      dispatch(addInvoice(finalValues)).then((res) => { if (!res.error) navigate("/invoice"); });
    }
  };

  const ProductTotal = (props) => {
    const { values, touched, setFieldValue } = useFormikContext();
    async function getProductTotal(rate, quantity) {
      await new Promise((r) => setTimeout(r, 200));
      return ((parseFloat(rate) || 0) * (parseFloat(quantity) || 0)).toFixed(2);
    }
    useEffect(() => {
      const rate = values?.productDetail[props.index].rate;
      const quantity = values?.productDetail[props.index].quantity;
      getProductTotal(rate, quantity).then((total) => setFieldValue(props.name, total));
    }, [values?.productDetail, touched, props.name, props.index, setFieldValue]);
  };

  async function getInvoiceNetTotal(products) {
    await new Promise((r) => setTimeout(r, 200));
    return products?.reduce((sum, p) => sum + (parseFloat(p?.rate) || 0) * (parseFloat(p?.quantity) || 0), 0).toFixed(2);
  }
  async function getInvoiceDiscount(values) {
    await new Promise((r) => setTimeout(r, 200));
    return values?.productDetail?.reduce((sum, p) => sum + (parseFloat(p?.discountamount) || 0), 0).toFixed(2);
  }
  async function getInvoiceTax(values) {
    await new Promise((r) => setTimeout(r, 200));
    const netTotal = parseFloat(await getInvoiceNetTotal(values?.productDetail)) || 0;
    const discount = parseFloat(await getInvoiceDiscount(values)) || 0;
    const taxableAmount = netTotal - discount;
    if (taxType === 'percentage') {
      return ((taxableAmount * taxPercentage) / 100).toFixed(2);
    }
    return (0).toFixed(2);
  }
  async function getInvoiceTotal(values) {
    await new Promise((r) => setTimeout(r, 200));
    const netTotal = parseFloat(await getInvoiceNetTotal(values?.productDetail)) || 0;
    const discount = parseFloat(await getInvoiceDiscount(values)) || 0;
    const tax = parseFloat(await getInvoiceTax(values)) || 0;
    const shipping = parseFloat(String(values?.shippingCharge || 0).replace(/,/g, "")) || 0;
    return ((netTotal - discount) + tax + shipping).toFixed(2);
  }

  const CalculationField = (props) => {
    const { values, setFieldValue } = useFormikContext();
    useEffect(() => {
      getInvoiceNetTotal(values?.productDetail).then((t) => setFieldValue("netAmount", t));
      getInvoiceDiscount(values).then((t) => setFieldValue("invoiceDiscount", t));
      getInvoiceTax(values).then((t) => setFieldValue("invoiceTax", t));
      getInvoiceTotal(values).then((t) => setFieldValue("totalAmount", t));
    }, [values?.productDetail, values?.appliedTaxes, values?.appliedDiscounts, values?.shippingCharge, setFieldValue]);
  };

  return (
    <Spinner active={loading}>
      {/* ── Review Mode Header ── */}
      {isReviewMode && (
        <div
          className="d-flex justify-content-between align-items-center px-4 py-3 bg-white border-bottom"
          style={{ position: "sticky", top: 0, zIndex: 100, boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}
        >
          <div className="d-flex align-items-center gap-3">
            <button
              type="button"
              className="btn btn-light rounded-pill d-flex align-items-center gap-2 fw-semibold"
              style={{ fontSize: "13px" }}
              onClick={() => setIsReviewMode(false)}
            >
              <FaArrowLeft size={12} /> Back to Edit
            </button>
            <div>
              <div className="fw-bold text-dark" style={{ fontSize: "15px" }}>Review Invoice</div>
              <div className="text-muted" style={{ fontSize: "11px" }}>Check everything before sending</div>
            </div>
          </div>
          <div className="d-flex gap-2">
            <button
              className="btn btn-light rounded-pill px-4 fw-semibold d-flex align-items-center gap-2"
              style={{ fontSize: "13px" }}
              type="button"
              onClick={() => document.getElementById("btn-save-draft")?.click()}
            >
              <FaSave size={13} /> Save Draft
            </button>
            <button
              className="btn rounded-pill px-4 fw-semibold d-flex align-items-center gap-2 text-white"
              style={{ fontSize: "13px", background: "#28B0C4", border: "none" }}
              type="button"
              onClick={() => document.getElementById("btn-send-email")?.click()}
            >
              <IoIosSend size={15} /> Send Invoice
            </button>
          </div>
        </div>
      )}

      <div className={`invoice-form-container ${isReviewMode ? "review-active" : ""}`}>
        <div className="container-fluid px-0">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            enableReinitialize={true}
          >
            {(formik) => (
              <Form>
                <div className="row justify-content-center">

                  {/* ── Form Container ── */}
                  <div className={`col-12 col-xl-9 py-4 px-3 px-md-4 ${isReviewMode ? "d-none" : ""}`}>

                    {/* Page Title */}
                    <div className="d-flex align-items-center justify-content-between mb-4">
                      <div>
                        <h5 className="fw-bold text-dark mb-0">
                          {isOrder ? "Create New Order" : isEdit ? "Edit Invoice" : "Create Invoice"}
                        </h5>
                        <div className="text-muted" style={{ fontSize: "12px" }}>
                          {isOrder ? "Create a manual order and linked invoice" : isEdit ? "Update the invoice details below" : "Fill in the details to generate a new invoice"}
                        </div>
                      </div>
                      <span
                        className="rounded-pill px-3 py-1 fw-bold"
                        style={{ fontSize: "12px", background: "rgba(40,176,196,0.1)", color: "#28B0C4" }}
                      >
                        #{invoiceid}
                      </span>
                    </div>

                    {/* ── Section: Invoice Details ── */}
                    <div
                      className="bg-white rounded-4 p-4 mb-4"
                      style={{ border: "1px solid #f1f5f9", boxShadow: "0 1px 4px rgba(0,0,0,0.05)" }}
                    >
                      <div className="d-flex align-items-center gap-2 mb-4">
                        <div className="rounded-2" style={{ width: 4, height: 20, background: "#28B0C4" }} />
                        <h6 className="fw-bold text-dark mb-0" style={{ fontSize: "14px" }}>{isOrder ? "Order Details" : "Invoice Details"}</h6>
                      </div>

                      {/* Customer */}
                      <div className="mb-4">
                        <div className="d-flex align-items-center justify-content-between mb-1">
                          <label className="form-label fw-semibold text-dark mb-0" style={{ fontSize: "13px" }}>
                            Customer <span className="text-danger">*</span>
                          </label>
                          <button
                            type="button"
                            className="btn btn-link p-0 text-decoration-none d-flex align-items-center gap-1"
                            style={{ fontSize: "12px", color: "#28B0C4", fontWeight: 600 }}
                            onClick={() => setShowQuickAdd(true)}
                          >
                            <IoMdPersonAdd size={14} /> Quick Add
                          </button>
                        </div>
                        <Field name="customer">
                          {({ field, form: { setFieldValue } }) => (
                            <ReactSelect
                              options={customereoptions}
                              styles={selectStyles}
                              formatOptionLabel={(customer) => (
                                <div className="d-flex align-items-center gap-2">
                                  <div
                                    className="rounded-circle d-flex align-items-center justify-content-center fw-bold text-white flex-shrink-0"
                                    style={{ width: 28, height: 28, fontSize: "11px", backgroundColor: "#28B0C4" }}
                                  >
                                    {customer?.label?.charAt(0)}
                                  </div>
                                  <div>
                                    <div className="fw-bold" style={{ fontSize: "13px" }}>{customer?.label}</div>
                                    <div className="text-muted" style={{ fontSize: "11px" }}>{customer?.email}</div>
                                  </div>
                                </div>
                              )}
                              placeholder="Select a customer..."
                              isSearchable
                              onChange={(option) => {
                                setFieldValue(field.name, option?.value);
                                setFieldValue("selectedCustomer", option);
                              }}
                            />
                          )}
                        </Field>
                        <ErrorMessage name="customer" component="div" className="text-danger mt-1" style={{ fontSize: "12px" }} />
                      </div>

                      {/* Subject */}
                      <div className="mb-4">
                        <label className="form-label fw-semibold text-dark mb-1" style={{ fontSize: "13px" }}>Subject</label>
                        <Field
                          name="notes"
                          placeholder="e.g. Service for June 2025"
                          className="form-control"
                          style={{ borderRadius: "10px", border: "1.5px solid #e2e8f0", background: "#f8fafc", fontSize: "14px", padding: "10px 14px" }}
                        />
                      </div>

                      {/* Due Date + Currency */}
                      <div className="row g-3">
                        <div className="col-md-6">
                          <label className="form-label fw-semibold text-dark mb-1" style={{ fontSize: "13px" }}>Due Date</label>
                          <Field name="invoiceDueDate">
                            {({ field, form: { setFieldValue } }) => (
                              <div className="position-relative">
                                <ReactDatePicker
                                  dateFormat="dd MMMM yyyy"
                                  placeholderText="Select due date"
                                  className="form-control"
                                  style={{ borderRadius: "10px", border: "1.5px solid #e2e8f0", background: "#f8fafc", fontSize: "14px", width: "100%" }}
                                  selected={field.value ? new Date(field.value) : null}
                                  onChange={(val) => setFieldValue(field.name, moment(val).format("YYYY-MM-DD"))}
                                />
                                <i className="far fa-calendar position-absolute top-50 end-0 translate-middle-y me-3 text-muted" style={{ pointerEvents: "none" }} />
                              </div>
                            )}
                          </Field>
                          <ErrorMessage name="invoiceDueDate" component="div" className="text-danger mt-1" style={{ fontSize: "12px" }} />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label fw-semibold text-dark mb-1" style={{ fontSize: "13px" }}>
                            Currency <span className="text-danger">*</span>
                          </label>
                          <Field name="currency">
                            {({ field, form: { setFieldValue } }) => (
                              <ReactSelect
                                options={currencyoptions}
                                styles={selectStyles}
                                placeholder="Select currency..."
                                isSearchable
                                value={currencyoptions?.find(opt => opt.value === field.value)}
                                onChange={(option) => setFieldValue(field.name, option?.value)}
                              />
                            )}
                          </Field>
                          <ErrorMessage name="currency" component="div" className="text-danger mt-1" style={{ fontSize: "12px" }} />
                        </div>
                      </div>
                    </div>

                    {/* ── Section: Products ── */}
                    <div
                      className="bg-white rounded-4 p-4 mb-4"
                      style={{ border: "1px solid #f1f5f9", boxShadow: "0 1px 4px rgba(0,0,0,0.05)" }}
                    >
                      <div className="d-flex align-items-center gap-2 mb-4">
                        <div className="rounded-2" style={{ width: 4, height: 20, background: "#28B0C4" }} />
                        <h6 className="fw-bold text-dark mb-0" style={{ fontSize: "14px" }}>Line Items</h6>
                      </div>

                      <FieldArray name="productDetail">
                        {({ remove, push }) => (
                          <>
                            {formik.values.productDetail.map((item, index) => (
                              <div
                                key={index}
                                className="mb-3 p-3 rounded-3 position-relative"
                                style={{ background: "#f8fafc", border: "1.5px solid #e2e8f0" }}
                              >
                                {/* Row number + delete */}
                                <div className="d-flex align-items-center justify-content-between mb-3">
                                  <span
                                    className="fw-bold rounded-pill px-2 py-1"
                                    style={{ fontSize: "11px", background: "rgba(40,176,196,0.1)", color: "#28B0C4" }}
                                  >
                                    Item {index + 1}
                                  </span>
                                  {formik.values.productDetail.length > 1 && (
                                    <button
                                      type="button"
                                      className="btn btn-light rounded-circle p-1"
                                      style={{ width: 28, height: 28, lineHeight: 1 }}
                                      onClick={() => remove(index)}
                                    >
                                      <MdDelete size={14} className="text-danger" />
                                    </button>
                                  )}
                                </div>

                                <div className="row g-3">
                                  <div className="col-12 col-md-5">
                                    <label className="form-label fw-semibold mb-1" style={{ fontSize: "12px", color: "#64748b" }}>Product</label>
                                    <Field name={`productDetail.${index}.product`}>
                                      {({ field, form: { setFieldValue } }) => (
                                        <ReactSelect
                                          options={productsoptions}
                                          styles={smallSelectStyles}
                                          placeholder="Select product..."
                                          value={productsoptions?.find(opt => opt.value === field.value)}
                                          onChange={(option) => {
                                            setFieldValue(field.name, option.value);
                                            setFieldValue(`productDetail.${index}.productName`, option.label);
                                            
                                            // Use tiered price for initial selection
                                            const qty = parseFloat(formik.values.productDetail[index].quantity) || 1;
                                            const price = calculateTieredPrice(option, qty);
                                            
                                            setFieldValue(`productDetail.${index}.rate`, price);
                                            setFieldValue(`productDetail.${index}.total`, (price * qty).toFixed(2));
                                          }}
                                        />
                                      )}
                                    </Field>
                                    <ErrorMessage name={`productDetail.${index}.product`} component="div" className="text-danger mt-1" style={{ fontSize: "11px" }} />
                                  </div>
                                  <div className="col-4 col-md-2">
                                    <label className="form-label fw-semibold mb-1" style={{ fontSize: "12px", color: "#64748b" }}>Qty</label>
                                    <Field name={`productDetail.${index}.quantity`}>
                                      {({ field, form: { setFieldValue, values } }) => (
                                        <input
                                          {...field}
                                          type="number"
                                          min="1"
                                          className="form-control"
                                          style={{ borderRadius: "10px", border: "1.5px solid #e2e8f0", background: "white", fontSize: "13px", padding: "8px 12px" }}
                                          onChange={(e) => {
                                            const newQty = parseFloat(e.target.value) || 0;
                                            setFieldValue(field.name, newQty);
                                            
                                            // Recalculate rate based on tiered pricing
                                            const productId = values.productDetail[index].product;
                                            const product = productsoptions?.find(p => p.value === productId);
                                            if (product) {
                                              const newRate = calculateTieredPrice(product, newQty);
                                              setFieldValue(`productDetail.${index}.rate`, newRate);
                                            }
                                          }}
                                        />
                                      )}
                                    </Field>
                                  </div>
                                  <div className="col-4 col-md-2">
                                    <label className="form-label fw-semibold mb-1" style={{ fontSize: "12px", color: "#64748b" }}>Rate</label>
                                    <Field
                                      name={`productDetail.${index}.rate`}
                                      type="number"
                                      min="0"
                                      step="0.01"
                                      className="form-control"
                                      style={{ borderRadius: "10px", border: "1.5px solid #e2e8f0", background: "white", fontSize: "13px", padding: "8px 12px" }}
                                    />
                                  </div>
                                  <div className="col-4 col-md-3">
                                    <label className="form-label fw-semibold mb-1" style={{ fontSize: "12px", color: "#64748b" }}>Total</label>
                                    <div
                                      className="d-flex align-items-center justify-content-center fw-bold rounded-3"
                                      style={{
                                        height: "38px", background: "rgba(40,176,196,0.08)",
                                        color: "#28B0C4", fontSize: "14px", border: "1.5px solid rgba(40,176,196,0.2)"
                                      }}
                                    >
                                      {formatCurrency(formik.values.productDetail[index].total || 0, currencyContext)}
                                    </div>
                                    <ProductTotal name={`productDetail.${index}.total`} index={index} />
                                  </div>
                                </div>

                                {/* Discount row */}
                                <div className="mt-3 pt-2 border-top">
                                  <label className="form-label fw-semibold mb-1" style={{ fontSize: "12px", color: "#64748b" }}>Discounts</label>
                                  <FieldArray name={`productDetail.${index}.discountList`}>
                                    {({ push, remove: removeDiscount }) => (
                                      <div className="d-flex align-items-center gap-2 flex-wrap">
                                        <div style={{ minWidth: "200px", flex: 1 }}>
                                          <ReactSelect
                                            placeholder="Add discount..."
                                            options={dynamicDiscountOptions}
                                            styles={smallSelectStyles}
                                            onChange={(option) => {
                                              const rate = parseFloat(formik.values.productDetail[index].rate) || 0;
                                              const qty = parseFloat(formik.values.productDetail[index].quantity) || 0;
                                              const amount = option.type === "flat" ? option.rate : (rate * qty * option.rate) / 100;
                                              push({ name: option.name, rate: option.rate, type: option.type, discountId: option.value });
                                              formik.setFieldValue(`productDetail.${index}.discountamount`, (parseFloat(formik.values.productDetail[index].discountamount) || 0) + amount);
                                            }}
                                          />
                                        </div>
                                        {formik.values.productDetail[index].discountList?.map((d, di) => (
                                          <span
                                            key={di}
                                            className="d-inline-flex align-items-center gap-1 rounded-pill px-2 py-1"
                                            style={{ fontSize: "11px", background: "#fee2e2", color: "#ef4444", fontWeight: 600 }}
                                          >
                                            {d.name} ({d.type === 'flat' ? `$${d.rate}` : `${d.rate}%`})
                                            <MdDelete
                                              size={12}
                                              style={{ cursor: "pointer" }}
                                              onClick={() => {
                                                const rate = parseFloat(formik.values.productDetail[index].rate) || 0;
                                                const qty = parseFloat(formik.values.productDetail[index].quantity) || 0;
                                                const amount = d.type === "flat" ? d.rate : (rate * qty * d.rate) / 100;
                                                removeDiscount(di);
                                                formik.setFieldValue(`productDetail.${index}.discountamount`, (parseFloat(formik.values.productDetail[index].discountamount) || 0) - amount);
                                              }}
                                            />
                                          </span>
                                        ))}
                                      </div>
                                    )}
                                  </FieldArray>
                                </div>
                              </div>
                            ))}

                            <button
                              type="button"
                              className="btn rounded-pill d-flex align-items-center gap-2 fw-semibold mt-2"
                              style={{ fontSize: "13px", border: "1.5px dashed #28B0C4", color: "#28B0C4", background: "rgba(40,176,196,0.04)", padding: "8px 16px" }}
                              onClick={() => push({ product: "", productName: "", quantity: 1, rate: 0, total: 0, discountList: [], discountamount: 0, tax: 0 })}
                            >
                              <IoMdAddCircle size={16} /> Add Line Item
                            </button>
                          </>
                        )}
                      </FieldArray>
                    </div>

                    {/* ── Section: Summary + Notes ── */}
                    <div
                      className="bg-white rounded-4 p-4 mb-4"
                      style={{ border: "1px solid #f1f5f9", boxShadow: "0 1px 4px rgba(0,0,0,0.05)" }}
                    >
                      <div className="d-flex align-items-center gap-2 mb-4">
                        <div className="rounded-2" style={{ width: 4, height: 20, background: "#28B0C4" }} />
                        <h6 className="fw-bold text-dark mb-0" style={{ fontSize: "14px" }}>Summary & Notes</h6>
                      </div>

                      <div className="row g-4">
                        {/* Notes */}
                        <div className="col-md-6">
                          <label className="form-label fw-semibold text-dark mb-1" style={{ fontSize: "13px" }}>Notes / Terms</label>
                          <Field
                            as="textarea"
                            name="terms"
                            placeholder="Payment terms, conditions, or a thank-you note..."
                            className="form-control"
                            style={{ borderRadius: "10px", border: "1.5px solid #e2e8f0", background: "#f8fafc", fontSize: "13px", height: "140px", padding: "12px 14px", resize: "none" }}
                          />
                        </div>

                        {/* Calculation card */}
                        <div className="col-md-6">
                          <div className="rounded-3 p-3" style={{ background: "#f8fafc", border: "1.5px solid #e2e8f0" }}>

                            <div className="d-flex justify-content-between align-items-center mb-2 pb-2 border-bottom">
                              <span className="text-muted fw-medium" style={{ fontSize: "13px" }}>Subtotal</span>
                              <span className="fw-bold" style={{ fontSize: "14px" }}>
                                {formatCurrency(formik.values.netAmount || 0, currencyContext)}
                              </span>
                            </div>

                            <div className="d-flex justify-content-between align-items-center mb-3">
                              <span className="text-muted fw-medium" style={{ fontSize: "13px" }}>Discount</span>
                              <span className="fw-bold" style={{ fontSize: "14px", color: "#ef4444" }}>
                                -{formatCurrency(formik.values.invoiceDiscount || 0, currencyContext)}
                              </span>
                            </div>

                            {taxType === 'percentage' && (
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                <span className="text-muted fw-medium" style={{ fontSize: "13px" }}>{taxLabel} ({taxPercentage}%)</span>
                                <span className="fw-bold" style={{ fontSize: "14px", color: "#10b981" }}>
                                  +{formatCurrency(formik.values.invoiceTax || 0, currencyContext)}
                                </span>
                              </div>
                            )}

                            <div className="mb-3">
                              <label className="form-label fw-semibold mb-1" style={{ fontSize: "12px", color: "#64748b" }}>Shipping</label>
                              <CurrencyInput
                                name="shippingCharge"
                                className="form-control"
                                style={{ borderRadius: "10px", border: "1.5px solid #e2e8f0", background: "white", fontSize: "13px", padding: "8px 12px" }}
                                placeholder="$0.00"
                                prefix="$"
                                decimalsLimit={2}
                                value={formik.values.shippingCharge}
                                onValueChange={(value) => formik.setFieldValue("shippingCharge", value)}
                              />
                            </div>

                            <div
                              className="d-flex justify-content-between align-items-center rounded-3 p-3"
                              style={{ background: "rgba(40,176,196,0.08)", border: "1.5px solid rgba(40,176,196,0.2)" }}
                            >
                              <span className="fw-bold text-dark" style={{ fontSize: "14px" }}>Grand Total</span>
                              <span className="fw-bold" style={{ fontSize: "20px", color: "#28B0C4" }}>
                                {formatCurrency(formik.values.totalAmount || 0, currencyContext)}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* ── Section: Recurring ── */}
                    <div
                      className="bg-white rounded-4 p-4 mb-4"
                      style={{ border: "1px solid #f1f5f9", boxShadow: "0 1px 4px rgba(0,0,0,0.05)" }}
                    >
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center gap-2">
                          <div className="rounded-2" style={{ width: 4, height: 20, background: "#28B0C4" }} />
                          <div>
                            <h6 className="fw-bold text-dark mb-0" style={{ fontSize: "14px" }}>Recurring Invoice</h6>
                            <div className="text-muted" style={{ fontSize: "11px" }}>Automatically re-send this invoice on a schedule</div>
                          </div>
                        </div>
                        <label className="toggle-switch mb-0">
                          <Field
                            type="checkbox"
                            name="recurring.isRecurring"
                            onChange={(e) => {
                              formik.setFieldValue("recurring.isRecurring", e.target.checked);
                              setRecurringChecked(e.target.checked);
                            }}
                          />
                          <span className="slider round"></span>
                        </label>
                      </div>

                      {formik.values.recurring?.isRecurring && (
                        <div className="mt-4 pt-3 border-top">
                          <div className="row g-3">
                            <div className="col-md-6">
                              <label className="form-label fw-semibold text-dark mb-1" style={{ fontSize: "13px" }}>Interval</label>
                              <Field
                                as="select"
                                name="recurring.interval"
                                className="form-select"
                                style={{ borderRadius: "10px", border: "1.5px solid #e2e8f0", background: "#f8fafc", fontSize: "13px", padding: "10px 14px" }}
                              >
                                <option value="yearly">Yearly</option>
                                <option value="half-yearly">Half Yearly</option>
                                <option value="trimister">Trimester</option>
                                <option value="monthly">Monthly</option>
                                <option value="bi-weekly">Bi-weekly</option>
                                <option value="weekly">Weekly</option>
                                <option value="custom">Custom</option>
                              </Field>
                            </div>
                            <div className="col-md-6">
                              <label className="form-label fw-semibold text-dark mb-1" style={{ fontSize: "13px" }}>End After</label>
                              <Field
                                as="select"
                                name="recurring.recurrenceEndType"
                                className="form-select"
                                style={{ borderRadius: "10px", border: "1.5px solid #e2e8f0", background: "#f8fafc", fontSize: "13px", padding: "10px 14px" }}
                              >
                                <option value="continuous">Indefinitely</option>
                                <option value="numberOfInvoices">Fixed Number of Invoices</option>
                                <option value="endDate">Specific Date</option>
                              </Field>
                            </div>
                            {formik.values.recurring?.recurrenceEndType === "numberOfInvoices" && (
                              <div className="col-md-6">
                                <label className="form-label fw-semibold text-dark mb-1" style={{ fontSize: "13px" }}>Number of Invoices</label>
                                <Field
                                  name="recurring.numberOfInvoices"
                                  type="number"
                                  className="form-control"
                                  style={{ borderRadius: "10px", border: "1.5px solid #e2e8f0", background: "#f8fafc", fontSize: "13px", padding: "10px 14px" }}
                                />
                              </div>
                            )}
                            {formik.values.recurring?.recurrenceEndType === "endDate" && (
                              <div className="col-md-6">
                                <label className="form-label fw-semibold text-dark mb-1" style={{ fontSize: "13px" }}>End Date</label>
                                <Field name="recurring.endDate">
                                  {({ field, form: { setFieldValue } }) => (
                                    <ReactDatePicker
                                      dateFormat="dd MMMM yyyy"
                                      className="form-control"
                                      style={{ borderRadius: "10px", border: "1.5px solid #e2e8f0", fontSize: "13px" }}
                                      selected={field.value ? new Date(field.value) : null}
                                      onChange={(val) => setFieldValue(field.name, moment(val).format("YYYY-MM-DD"))}
                                    />
                                  )}
                                </Field>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    {/* ── Action Buttons ── */}
                    <div className="d-flex justify-content-between align-items-center mt-2 pb-4">
                      <button
                              style={{ fontSize: "13px" }}
                        onClick={() => navigate("/invoice")}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn rounded-pill px-5 fw-bold d-flex align-items-center gap-2 text-white"
                        style={{ fontSize: "14px", background: "#28B0C4", border: "none", padding: "12px 28px", boxShadow: "0 4px 14px rgba(40,176,196,0.35)" }}
                        onClick={async () => {
                          const errors = await formik.validateForm();
                          if (Object.keys(errors).length === 0) {
                            setIsReviewMode(true);
                            window.scrollTo(0, 0);
                          } else {
                            formik.setTouched(
                              Object.keys(formik.initialValues).reduce((acc, key) => { acc[key] = true; return acc; }, {})
                            );
                            const firstError = document.querySelector(".text-danger");
                            if (firstError) firstError.scrollIntoView({ behavior: "smooth", block: "center" });
                          }
                        }}
                      >
                        Continue to Review {isOrder ? "" : <IoIosSend size={16} />}
                      </button>
                    </div>
                  </div>

                  {/* ── Review Mode ── */}
                  {isReviewMode && (
                    <div className="col-12 p-0 animate__animated animate__fadeIn">
                      <InvoicePreview
                        data={formik.values}
                        selectedBusiness={selectedBusiness}
                        selectedCustomer={formik.values.selectedCustomer}
                      />
                    </div>
                  )}
                </div>

                <CalculationField name="netAmount" />

                <div className="d-none">
                  <button id="btn-save-draft" type="button" onClick={() => { formik.setFieldValue("status", "Draft"); formik.handleSubmit(); }}>Save</button>
                  <button id="btn-send-email" type="button" onClick={() => { formik.setFieldValue("status", "Sent"); formik.handleSubmit(); }}>{isOrder ? "Create Order" : "Send"}</button>
                </div>

                {/* ── Quick Add Customer Modal ── */}
                <Modal show={showQuickAdd} onHide={() => setShowQuickAdd(false)} centered className="premium-modal">
                  <Modal.Header closeButton className="border-0">
                    <Modal.Title className="fw-bold">Quick Add Customer</Modal.Title>
                  </Modal.Header>
                  <Modal.Body className="px-4 pb-4">
                    <div className="mb-3">
                      <label className="form-label small fw-bold">Name <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        className="form-control gbl-input"
                        placeholder="Enter customer name"
                        value={quickCustomer.name}
                        onChange={(e) => setQuickCustomer({ ...quickCustomer, name: e.target.value })}
                      />
                    </div>
                    <div className="mb-4">
                      <label className="form-label small fw-bold">Email <span className="text-danger">*</span></label>
                      <input
                        type="email"
                        className="form-control gbl-input"
                        placeholder="customer@example.com"
                        value={quickCustomer.email}
                        onChange={(e) => setQuickCustomer({ ...quickCustomer, email: e.target.value })}
                      />
                    </div>
                    <div className="d-flex gap-2">
                      <button
                        type="button"
                        className="btn btn-light rounded-pill w-100 fw-bold"
                        onClick={() => setShowQuickAdd(false)}
                        disabled={customerLoading}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn text-white rounded-pill w-100 fw-bold"
                        style={{ background: "#28B0C4" }}
                        disabled={customerLoading || !quickCustomer.name || !quickCustomer.email}
                        onClick={() => {
                          const payload = {
                            ...quickCustomer,
                            business: selectedBusinessId,
                            currency: selectedBusiness?.currency?.code || selectedBusiness?.currency || "USD"
                          };
                          dispatch(addCustomer(payload)).then((res) => {
                            if (!res.error) {
                              const newCust = res.payload;
                              const option = {
                                label: newCust.name,
                                value: newCust._id,
                                email: newCust.email,
                                street: newCust.address?.street,
                                city: newCust.address?.city,
                                state: newCust.address?.state,
                                zipCode: newCust.address?.zipCode,
                                country: newCust.address?.country,
                              };
                              formik.setFieldValue("customer", newCust._id);
                              formik.setFieldValue("selectedCustomer", option);
                              setShowQuickAdd(false);
                              setQuickCustomer({ name: "", email: "" });
                            }
                          });
                        }}
                      >
                        {customerLoading ? "Adding..." : "Add Customer"}
                      </button>
                    </div>
                  </Modal.Body>
                </Modal>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </Spinner>
);
}